export const DELETE_STATEMENT_TEMPLATE_REQUEST = 'DELETE_STATEMENT_TEMPLATE_REQUEST';

export const deleteStatementTemplateRequest = ( id ) => ({
    type: DELETE_STATEMENT_TEMPLATE_REQUEST,
    payload: {
        id
    }
});
